module.exports = "/virtual-football-league/img/amblems/left/logos/FakeAstonVilla.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeAstonVilla.png
// module id = 2069
// module chunks = 4